// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__6jKL6","importantInfo":"styles_importantInfo__bu-yK"};